<!-- 最小孔径 -->
<template>
  <BaseFormItem2
    :unit="fields.unit"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup2 v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup2>
    <img slot="other" :src="require('@@/assets/img/pcb/vias_view.jpg')" />
  </BaseFormItem2>
</template>

<script>
import { getCOPPERFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [String, Number],
      default: 0.8
    },
    // 板子厚度
    bheight: {
      type: Number
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: +this.value
    }
  },
  computed: {
    fields() {
      return getCOPPERFields('vias')
    },
    options() {
      const { val, fields, bheight } = this
      const options = fields.options
      // 最小限制
      let disabledOptions = bheight > 1.2 ? 1.2 : { 1.0: 0.8, 1.2: 1.0 }[bheight]
      
      // 如果当前项被禁用
      if (val < disabledOptions) {
        // 选中最小可选选项
        this.changeVal(disabledOptions)
      }
      
      return options.map(item => ({...item, disabled: item.value < disabledOptions }))
    }
  },
  watch: {
    value(newVal) {
      this.val = +newVal
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      this.$topWarning.mergeFields(this.fields.label)
      this.val = val
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>